import styled, { css } from 'styled-components';
import { APPS_PHONE_MEDIA } from '../../apps.constants';

export const RemoveButton = styled.button`
  position: absolute;
  top: -6px;
  right: -6px;
  display: grid;
  place-items: center;
  width: 18px;
  height: 18px;
  padding: 0;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0;
  background: ${({ theme }) => theme.colors.inverseSurface};
  color: ${({ theme }) => theme.colors.inverseOnSurface};
  transition: opacity 0.15s ease;

  &:focus-visible {
    opacity: 1;
    outline: 2px solid ${({ theme }) => theme.colors.primary};
  }
`;

const tileSize = css`
  width: 44px;
  height: 44px;

  ${APPS_PHONE_MEDIA} {
    width: 34px;
    height: 34px;
  }
`;

export const Tile = styled.div`
  position: relative;
  display: flex;
  flex: none;
  ${tileSize};

  &:hover ${RemoveButton}, &:focus-within ${RemoveButton} {
    opacity: 1;
  }
`;

export const TileButton = styled.button<{ $filled: boolean }>`
  display: grid;
  place-items: center;
  ${tileSize};
  padding: 4px;
  border-radius: 10px;
  cursor: pointer;
  background: transparent;
  color: ${({ theme }) => theme.colors.onSurfaceVariant};
  border: 1px ${({ $filled }) => ($filled ? 'solid' : 'dashed')}
    ${({ theme, $filled }) => ($filled ? theme.colors.outlineVariant : theme.colors.outline)};
  transition: border-color 0.15s ease;

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.colors.primary};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }

  &:disabled {
    cursor: progress;
  }
`;

export const LogoImage = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;
